import { RequestCriteria, RequestModes } from './shared/RequestCriteria.js';
import { OnsiteComment } from './shared/OnsiteComment.js';
import { OnsiteVisit } from './shared/OnsiteVisit.js';

function OnsiteController($http, $interval, $location, $scope, $rootScope, onsiteSearchCriteriaFactory, onsiteService, onsiteSettingsService) {
    var refreshInterval = 10000,
        requestCanceled = false,
        inSound = new Audio('assets/sounds/double_doorbell.mp3'),
        outSound = new Audio('assets/sounds/triple_chime.mp3'),
        messageSound = new Audio('assets/sounds/message_ping.mp3'),
        playSounds = true,
        warningLevels = {
            levelOne: 8,
            levelTwo: 24
        },
        visitDataPrototype = {
            data: [],
            interval: null,
            promise: null,
            latest: null,
            firstLoad: true
        };

    $scope.activeView = 'dashboard';

    $scope.visits = _.create({}, visitDataPrototype);
    $scope.activeVisits = _.create({}, visitDataPrototype);
    $scope.comments = _.create({}, visitDataPrototype);
    $scope.reports = [];
    $scope.reportMap = {};
    $scope.filterReport = null;

    $scope.refresh = {
        inProgress: {
            activeVisits: false,
            comments: false,
            updatedVisits: false
        },
        isSuccessful: true,
        last: new Date()
    };

    $scope.phoneNumber = "";


    function finalize() {
        $interval.cancel($scope.comments.interval);
        $interval.cancel($scope.activeVisits.interval);
        $interval.cancel($scope.visits.interval);

        $scope.comments.interval = null;
        $scope.activeVisits.interval = null;
        $scope.visits.interval = null;
        
        $scope.refresh.inProgress.activeVisits = false;
        $scope.refresh.inProgress.comments = false;
        $scope.refresh.inProgress.updatedVisits = false;

        $scope.visits.data = [];
        $scope.activeVisits.data = [];
        $scope.comments.data = [];
    
        $scope.activeVisits.firstLoad = true;
    }

    function getActiveVisitResults(cancelCurrentRequest) {
        var avCriteria = new RequestCriteria($rootScope.selectedLog.id, getFilterReportId());
        avCriteria.activeOnly = true;

        if ($scope.activeVisits.promise && (!$scope.refresh.inProgress.activeVisits || !!cancelCurrentRequest)) {
            $scope.activeVisits.promise.cancel().then(function() {
                requestCanceled = true;
                $scope.activeVisits.promise = onsiteService.getVisits(avCriteria);
                $scope.activeVisits.promise
                    .then(onActiveVisitsReceived)
                    .catch(onUpdateFailure)
                    .finally(function(){
                        $scope.refresh.inProgress.activeVisits = false;
                    });
                $scope.refresh.inProgress.activeVisits = true;
            });
        } else if (!$scope.refresh.inProgress.activeVisits) {
            $scope.activeVisits.promise = onsiteService.getVisits(avCriteria);
            $scope.activeVisits.promise
                .then(onActiveVisitsReceived)
                .catch(onUpdateFailure)
                .finally(function(){
                    $scope.refresh.inProgress.activeVisits = false;
                });
            $scope.refresh.inProgress.activeVisits = true;
        }

        if(!$scope.activeVisits.interval){
            $scope.activeVisits.interval = $interval(function() {
                getActiveVisitResults();
            }, refreshInterval);
        }

        return $scope.activeVisits.promise;
    }

    function getCommentResults(cancelCurrentRequest) {
        if ($scope.comments.promise && (!$scope.refresh.inProgress.comments || !!cancelCurrentRequest)) {
            $scope.comments.promise.cancel().then(function() {
                requestCanceled = true;
                $scope.comments.promise = onsiteService.getComments($rootScope.selectedLog.id, getFilterReportId());
                $scope.comments.promise
                    .then(onCommentsReceived)
                    .catch(onUpdateFailure)
                    .finally(function(){
                        $scope.refresh.inProgress.comments = false;
                    });
                $scope.refresh.inProgress.comments = true;
            });
        } else if (!$scope.refresh.inProgress.comments) {
            $scope.comments.promise = onsiteService.getComments($rootScope.selectedLog.id, getFilterReportId());
            $scope.comments.promise
                .then(onCommentsReceived)
                .catch(onUpdateFailure)
                .finally(function(){
                    $scope.refresh.inProgress.comments = false;
                });
            $scope.refresh.inProgress.comments = true;
        }

        if(!$scope.comments.interval){
            $scope.comments.interval = $interval(function() {
                getCommentResults();
            }, refreshInterval);
        }

        return $scope.comments.promise;
    }

    function getVisitSearchResults(cancelCurrentRequest) {
            var requestCriteria = new RequestCriteria($rootScope.selectedLog.id, getFilterReportId(), onsiteSearchCriteriaFactory.get(), $scope.visits.latest);
            requestCriteria.size = 10000;

            if ($scope.visits.promise && $scope.visits.interval && (!$scope.refresh.inProgress.updatedVisits || !!cancelCurrentRequest)) {
                $scope.visits.promise.cancel().then(function () {
                    requestCanceled = true;
                    $scope.visits.promise = onsiteService.getVisits(requestCriteria);
                    $scope.visits.promise
                        .then(onSearchVisitsReceived)
                        .catch(onUpdateFailure)
                        .finally(function(){
                            $scope.refresh.inProgress.updatedVisits = false;
                        });
                    $scope.refresh.inProgress.updatedVisits = true;
                });
            } else if (!$scope.refresh.inProgress.updatedVisits) {
                $scope.visits.promise = onsiteService.getVisits(requestCriteria);
                $scope.visits.promise
                    .then(onSearchVisitsReceived)
                    .catch(onUpdateFailure)
                    .finally(function(){
                        $scope.refresh.inProgress.updatedVisits = false;
                    });
                $scope.refresh.inProgress.updatedVisits = true;
            }

            if (!$scope.visits.interval) {
                $scope.visits.interval = $interval(function () {
                    if (!$scope.refresh.inProgress.updatedVisits && moment().isSame(onsiteSearchCriteriaFactory.get().thruDate, "day")) {
                        getUpdatedVisitResults();
                    }
                }, refreshInterval);
            }
            return $scope.visits.promise;
    }

    function getReports() {
            return $http.get('/api/reports', {
                params: {
                    log: $rootScope.selectedLog.id,
                    activeRevision: true,
                    isViewNotesFilter: true,
                    projection: 'reportFilterProjection'
                }
            })
            .then(function(results)
            {
                $scope.reports = results.data._embedded.reports;
                $scope.reportMap = $scope.reports.reduce(function(map, report)
                {
                    map[report.complexObject.id] = report;
                    return map;
                }, {});
    
                // Clear filter if it is not within current filterable reports.
                if ($scope.filterReport && !($scope.filterReport in $scope.reportMap))
                {
                    $scope.filterReport = null;
                    filterChanged();
                }
            });
    }

    function getUpdatedVisitResults() {
        var requestCriteria = new RequestCriteria($rootScope.selectedLog.id, getFilterReportId(), onsiteSearchCriteriaFactory.get(), $scope.visits.latest);
        requestCriteria.size = 10000;
        requestCriteria.mode = RequestModes.UPDATE;

        $scope.visits.promise = onsiteService.getVisits(requestCriteria);
        $scope.visits.promise
            .then(onUpdateVisitsReceived)
            .catch(onUpdateFailure)
            .finally(function(){
                $scope.refresh.inProgress.updatedVisits = false;
            });
        
        $scope.refresh.inProgress.updatedVisits = true;
    }

    function onActiveVisitsReceived(response) {
        onUpdateSuccess();

        var diff = $scope.activeVisits.data.length - response.data._embedded.notes.length;

        if(!$scope.activeVisits.firstLoad) {
            if (diff < 0) {
                playSound("In");
            }

            if (diff > 0) {
                playSound("Out");
            }
        }

        $scope.activeVisits.firstLoad = false;


        $scope.activeVisits.data = response.data._embedded.notes.map(function(note) {
            return new OnsiteVisit(note, warningLevels);
        });


        $scope.activeVisits.promise = null;
    }

    function onCommentsReceived(response) {
        onUpdateSuccess();

        var newComments = response.data._embedded.noteComments.map(function(nc) {
            return new OnsiteComment(nc);
        });


        var diff = ($scope.comments.data.length > 0 && newComments.length > 0)
                    && $scope.comments.data[0].id !== newComments[0].id
                    && (newComments[0].createdBy === "Onsite Service" )
                    && (newComments[0].comment.match(/Reason:/m) === null);


        if(!$scope.comments.firstLoad && diff) {
            playSound("Ping");
        }

        $scope.comments.firstLoad = false;
        $scope.comments.data = newComments;
        $scope.comments.promise = null;
    }
    
    function getFilterReport()
    {
        return $scope.reportMap[$scope.filterReport] ? $scope.reportMap[$scope.filterReport] : null;
    }
    
    function getFilterReportId()
    {
        var report = getFilterReport();
        return report ? report.id : null;
    }

    function onLogUpdated(selectedLog) {
        finalize();

        if (selectedLog) {
            onsiteSettingsService.getOnSiteSettingsByLogId($rootScope.selectedLog.id).then(function(settings) {
                if (!settings._embedded || (settings._embedded.log.id !== $rootScope.selectedLog.id) || !settings.phoneNumber || !selectedLog.onsiteEnabled) {
                    finalize();
                    $location.url('/notes');
                    return;
                }

                $scope.phoneNumber = settings.phoneNumber;

                warningLevels = {
                    levelOne: settings.levelOneWarning,
                    levelTwo: settings.levelTwoWarning
                };

                onsiteSettingsService.getLogUserConfigsByLogId($rootScope.selectedLog.id).then(function (configs){
                    playSounds = configs.OnsiteSounds.value;
                });

                getReports()
                    .finally(function()
                    {
                        refreshView();
                    });
            });
        }
    }

    function onSearchVisitsReceived(response) {
        onUpdateSuccess();
        $scope.visits.latest = new Date();

        $scope.visits.data = response.data._embedded.notes.map(function(note) {
            return new OnsiteVisit(note, warningLevels);
        });

        $scope.visits.promise = null;
    }

    function onUpdateVisitsReceived(response) {
        onUpdateSuccess();
        $scope.visits.latest = new Date();

        var newData = response.data._embedded.notes.map(function(note) {
            return new OnsiteVisit(note, warningLevels);
        });

        newData.forEach(function(visit) {
            var ind = $scope.visits.data.findIndex(function(existing) {
                return existing.noteId === visit.noteId;
            });

            if (ind > -1) {
                $scope.visits.data[ind] = visit;
            } else {
                $scope.visits.data.push(visit);
            }
        });

        $scope.visits.promise = null;
    }

    function onViewChanged(event, activeView) {
        $scope.activeVisits.firstLoad = true;
        $scope.comments.firstLoad = true;
        finalize();
        refreshView(activeView);
    }

    function onUpdateFailure(error) {
        if (!requestCanceled) {
            $scope.refresh.isSuccessful = false;
            if ((error === 'Forbidden' || error.status === 403) && $scope.filterReport)
            {
                getReports();
            }
        }
        requestCanceled = false;
    }

    function onUpdateSuccess() {
        $scope.refresh.isSuccessful = true;
        $scope.refresh.last = new Date();
    }

    function refreshView(activeView) {
        activeView = activeView || $scope.activeView;

        if (activeView === 'dashboard') {
            if($scope.visits.promise)
                $scope.visits.promise.cancel();
            if($scope.visits.interval)
                $interval.cancel($scope.visits.interval);

            getActiveVisitResults();
            getCommentResults();
        } else {
            getVisitSearchResults();
        }
    }
    
    function filterChanged() {
        $rootScope.selectedLog.activeLogUser.defaultReportFilter = getFilterReport();
        $location.search('report', $scope.filterReport).replace();
        finalize();
        refreshView();
    }

    function onVisitCreated(event, visit){
        $scope.activeVisits.data = $scope.activeVisits.data.filter(function(v){ 
            return v.phoneNumber !== visit.phoneNumber 
        });
        $scope.activeVisits.data.push(visit);

        var visitIndex = $scope.visits.data.findIndex(function(v){ 
            return v.phoneNumber === visit.phoneNumber &&  !v.timeOut 
        });

        if(visitIndex >= 0 ){
            $scope.visits.data[visitIndex].timeOut = moment().toDate();
        }
            
        $scope.visits.data.push(visit);
    }

    function onVisitRemoved(event, visit){
        $scope.activeVisits.data = $scope.activeVisits.data.filter(function(v){ 
            return v.noteId !== visit.noteId 
        });

        var visitIndex = $scope.visits.data.findIndex(function(v){ return v.noteId === visit.noteId });

        if(visitIndex >= 0 ){
            $scope.visits.data[visitIndex] = visit;
        }
    }

    function playSound(soundType) {
        var sound = soundType === 'Out' ? outSound : soundType === "Ping" ? messageSound : inSound;

        if (sound != null && playSounds) {
            try {
                sound.play();
            } catch(err) {
                console.error("There was a change in the number of visits but could not play sound.");
            }
        }
    }

    (function() {
        if ($location.search()['report'] !== 'false')
        {
            var searchReport = parseInt($location.search()['report']);
            
            if (!isNaN(searchReport))
                $scope.filterReport = searchReport;
            else if ($scope.selectedLog.activeLogUser.defaultReportFilter)
                $scope.filterReport = $scope.selectedLog.activeLogUser.defaultReportFilter.complexObject.id;
            else if ($scope.selectedLog.defaultReportFilter && !$scope.selectedLog.activeLogUser.suppressReportFilter)
                $scope.filterReport = $scope.selectedLog.defaultReportFilter.complexObject.id;
        }
        
        onLogUpdated($scope.selectedLog);
        $scope.$on('onsite-search-criteria-changed', onViewChanged);
        $scope.$on('onsite-view-changed', onViewChanged);
        $scope.$on('refresh-requested', refreshView);
        $scope.$on('visit-added', onVisitCreated );
        $scope.$on('visit-removed', onVisitRemoved);
        $scope.$on('onsite-filter-changed', filterChanged)
        $scope.$on('$destroy', finalize);

    })();
}

angular.module('onsite').controller('onsiteController', ['$http', '$interval', '$location', '$scope', '$rootScope', 'onsiteSearchCriteriaFactory', 'onsiteService', 'onsiteSettingsService', OnsiteController]);